import { render, staticRenderFns } from "./SearchProductList.vue?vue&type=template&id=68a16ca4&"
import script from "./SearchProductList.vue?vue&type=script&lang=js&"
export * from "./SearchProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchItemPlaceHolder: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchItemPlaceHolder.vue').default,SearchProductCarousel: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/search/SearchProductCarousel.vue').default})
